import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { Printer } from "lucide-react";

// A one-pager to hand across the counter. Printed, not emailed — that's how shops actually
// get signed up in Trinidad. Uses the browser's own print dialogue, no PDF dependency.
const SITE = process.env.REACT_APP_BACKEND_URL;

const Point = ({ n, title, body }) => (
  <div className="flex gap-3">
    <span className="shrink-0 h-7 w-7 rounded-full bg-[#16a34a] text-white font-extrabold text-sm grid place-items-center">{n}</span>
    <div>
      <p className="font-bold text-[#0f2a1a]">{title}</p>
      <p className="text-sm text-[#44544a]">{body}</p>
    </div>
  </div>
);

const PitchSheet = () => (
  <div className="min-h-screen bg-[#f4f6f5] py-8 print:bg-white print:py-0">
    <div className="max-w-[820px] mx-auto px-4 print:px-0">
      <button onClick={() => window.print()} data-testid="print-pitch-btn"
        className="mb-4 print:hidden inline-flex items-center gap-2 bg-[#0f2a1a] hover:bg-[#16341f] text-white font-bold text-sm rounded-xl px-5 py-3 transition-colors">
        <Printer size={16} /> Print this page
      </button>

      <div className="bg-white rounded-2xl print:rounded-none shadow print:shadow-none overflow-hidden" data-testid="pitch-sheet">
        <div className="bg-[#0f2a1a] text-white px-8 py-6">
          <p className="text-2xl font-extrabold tracking-tight">LytePress</p>
          <p className="text-[#a7d8b8] text-sm mt-1">The deals map for Trinidad &amp; Tobago</p>
        </div>

        <div className="px-8 py-7">
          <h1 className="text-3xl font-extrabold text-[#0f2a1a] leading-tight">
            Put your special on the map. Free.
          </h1>
          <p className="text-[#44544a] mt-2">
            Shoppers near you open LytePress to see what's on today — closest deals first. Post yours in
            two minutes and you'll show up on their map with a pin, your hours and directions.
          </p>

          <div className="grid sm:grid-cols-2 gap-5 mt-6">
            <div className="space-y-4">
              <Point n="1" title="Post in two minutes" body="Photo, price, end date. No listing fee, no commission on what you sell." />
              <Point n="2" title="Get found by people nearby" body="Your pin shows on the map with directions, opening hours and your phone number." />
              <Point n="3" title="See what it did" body="Views, taps for directions and how many people grabbed your deal." />
              <Point n="4" title="Two live deals free, always" body="Upgrade only if you want more deals at once or a verified badge." />
            </div>

            <div className="bg-[#e7f6ec] rounded-xl p-5 text-center">
              <p className="font-extrabold text-[#0f2a1a]">Scan to sign up</p>
              <p className="text-xs text-[#44544a] mb-3">Free — no card needed</p>
              <div className="bg-white p-3 rounded-lg inline-block">
                <QRCodeSVG value={`${SITE}/register?ref=pitch`} size={148} level="M" />
              </div>
              <p className="text-xs text-[#44544a] mt-3 break-all">{(SITE || "").replace(/^https?:\/\//, "")}</p>
            </div>
          </div>

          <div className="mt-7 border-t border-[#e3e8e5] pt-4 flex flex-wrap items-center justify-between gap-2">
            <p className="text-sm text-[#44544a]">
              Questions? <strong>support@lytepress.com</strong>
            </p>
            <p className="text-xs text-[#7b8a81]">Shops keep every dollar they take at the counter.</p>
          </div>
        </div>
      </div>

      <p className="text-xs text-muted-foreground mt-4 print:hidden">
        Tip: print in colour, A4, "Fit to page". Two of these on a clipboard is a morning's worth of door-knocking.
        {" "}Sending it instead? Use the <a href="/overview" className="underline font-semibold" data-testid="pitch-overview-link">shareable overview</a>.
      </p>
    </div>
  </div>
);

export default PitchSheet;
